import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function KIYGCardContent() {
  const navigate = useNavigate();

  const CARDS = [
    {
      img: "img/kiyg25-VENUES.jpg",
      title: "Venues",
      description: "",
      path: "/khelo-india-youth-games-2025-venues",
      // path: "#",
    },
    {
      img: "img/kiyg25-schedule.jpg",
      title: "Schedule",
      description: "",
      path: "/khelo-india-youth-games-2025-schedule"
      // path: "#",
    },
    {
      img: "img/kiyg25-game.jpg",
      title: "Events",
      description: "",
      // path: "/link3",
      path: "/khelo-india-youth-games-2025-games",
    },
    {
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH8oN9d_tXaJo2jWN6O577eX8GyiyxeU0vtQ&s",
      title: "Health Facilities",
      description: "",
      // path: "/link3",
      path: "/khelo-india-youth-games-2025-medical",
    },
    {
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTa0V1XxVTLwRXcgBuRcOcsBvAvaXdyUY8Xag&s",
      title: "Medal Tally",
      description: "",
      // path: "/link3",
      path: "/khelo-india-youth-games-2025-results",
    },
  ];

  const cardStyle = {
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    transition: "transform 0.2s, box-shadow 0.2s",
    cursor: "pointer",
    // height: "200px", // Ensure consistent card height
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };

  const cardHoverStyle = {
    transform: "scale(1.05)",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
  };
  return (
    <>
      <Row gutter={[16, 16]}>
        {CARDS.map((card, index) => (
          <Col
            key={index}
            xs={24}
            sm={12}
            md={6}
            lg={4}
            style={{ padding: "1.5%" }}
          >
            <a href={card.path}>
              <Card
                style={cardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = cardHoverStyle.transform;
                  e.currentTarget.style.boxShadow = cardHoverStyle.boxShadow;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = cardStyle.boxShadow;
                }}
                // onClick={() => navigate(card.path)}
              >
                <Card.Body>
                  <div className="text-center">
                    <Card.Img
                      src={card.img}
                      style={{
                        objectFit: "fill",
                        width: "100%",
                        height: "200px",
                        marginBottom: "10px",
                      }}
                    />
                    <Card.Title><b>{card.title}</b></Card.Title>
                    <Card.Text>{card.description}</Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </a>
          </Col>
        ))}
      </Row>
    </>
  );
}
